
import { mapState, mapGetters, mapActions } from "vuex";
import CurrencyConverter from "../common/currency-converter.vue";
import NoDataLabel from "../common/no-data-label.vue";
import ItemWiseSalesDetailDialog from "../dialogs/item-wise-sales-detail-dialog.vue";
import ReportItemWiseSalesTableCategoryHeader from "./report-item-wise-sales-table-category-header.vue";
import reportPrintTitleReportName from "./report-print-title-report-name.vue";
import { itemWiseSalesHeaderForPdf } from "../../constants/Others";
export default {
  components: {
    reportPrintTitleReportName,
    ReportItemWiseSalesTableCategoryHeader,
    NoDataLabel,
    ItemWiseSalesDetailDialog,
    CurrencyConverter
  },
  props: {
    printMode: {
      default: false
    },
    hasPagination: {
      default: false
    },
    displayCategory: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      FIXED_TITLE: itemWiseSalesHeaderForPdf,
      PAGE_SIZES: [10, 25, 50, 100, "All"],
      sortBy: "",
      sortOrder: "",
      titles: [],
      items: [],
      printRownsInPage: 17,
      rowsOccupiedByHeader: 4,
      page: 1,
      pageSize: "All",
      itemTotalPrice: 0,
      showCategories: [],
      showSubCategories: [],
      mainCategoriesList: [],
      subCategoriesList: [],
      showItemWiseSalesDetails: false,
      selectedIndex: null
    };
  },
  computed: {
    ...mapState("report", [
      "products",
      "summary",
      "categories",
      "subCategories"
    ]),
    ...mapGetters("report", ["getChannels", "getTotalRevenue"]),
    averageRevenueFromItem() {
      return this.itemTotalPrice / this.products.length;
    },
    showAll() {
      return this.pageSize == "All";
    },
    showCategorySection() {
      return this.sortBy == "name" && this.displayCategory;
    },
    totalObj() {
      let totalObj = {
        label: "Total",
        count: 0,
        billable_amount: 0,
        total_taxes: 0,
        discount: 0,
        merchant_receivable_amount: 0
      };
      this.summary?.forEach((channel) => {
        totalObj.count += channel.count;
        totalObj.billable_amount += channel.billable_amount;
        totalObj.total_taxes += channel.total_taxes;
        totalObj.discount += channel.discount;
        totalObj.merchant_receivable_amount +=
          channel.merchant_receivable_amount;
      });
      return totalObj;
    },
    sortedItems() {
      var items = JSON.parse(JSON.stringify(this.items));
      if (this.sortBy) {
        const index =
          this.titles.findIndex((title) => title.value == this.sortBy) + 1;
        if (this.sortBy === "name") {
          if (this.displayCategory) {
            if (this.sortOrder == "asc") {
              items.sort((a, b) =>
                b[0].category_id == a[0].category_id
                  ? b[0].subcategory_id - a[0].subcategory_id
                  : b[0].category_id - a[0].category_id
              );
            } else {
              items.sort((a, b) =>
                b[0].category_id == a[0].category_id
                  ? a[0].subcategory_id - b[0].subcategory_id
                  : a[0].category_id - b[0].category_id
              );
            }
          } else {
            if (this.sortOrder == "asc") {
              items.sort((a, b) => (a[index].label > b[index].label ? 1 : -1));
            } else {
              items.sort((a, b) => (b[index].label > a[index].label ? 1 : -1));
            }
          }
        } else {
          if (this.sortOrder == "asc") {
            items.sort((a, b) => b[index].label - a[index].label);
          } else {
            items.sort((a, b) => a[index].label - b[index].label);
          }
        }
      }
      if (this.hasPagination && !this.showAll) {
        items = items.splice((this.page - 1) * this.pageSize, this.pageSize);
      }
      return items;
    }
  },
  mounted() {
    this.initData();
    if (!this.printMode) {
      this.sortBy = "name";
      this.sortOrder = "asc";
    }
  },
  watch: {
    products() {
      this.initData();
    }
  },
  methods: {
    getCategoryItemObj(id) {
      return this.mainCategoriesList.find((el) => el.id == id) || {};
    },
    getSubCategoryItemObj(id) {
      return this.subCategoriesList.find((el) => el.id == id) || {};
    },
    checkShowCategory(id) {
      return this.showCategories.includes(id);
    },
    checkShowSubCategory(id) {
      return this.showSubCategories.includes(id);
    },
    checkShowItem(row) {
      return (
        (this.showCategorySection && row[0].category_id
          ? this.checkShowCategory(row[0].category_id)
          : true) &&
        (row[0].subcategory_id
          ? this.checkShowSubCategory(row[0].subcategory_id)
          : true)
      );
    },
    handleCategoryClick(id) {
      if (this.checkShowCategory(id)) {
        this.showCategories.splice(this.showCategories.indexOf(id), 1);
      } else {
        this.showCategories.push(id);
      }
    },
    handleSubCategoryClick(id) {
      if (this.checkShowSubCategory(id)) {
        this.showSubCategories.splice(this.showSubCategories.indexOf(id), 1);
      } else {
        this.showSubCategories.push(id);
      }
    },
    initData() {
      this.items = [];
      this.itemTotalPrice = 0;
      const $this = this;
      this.mainCategoriesList = this.categories?.map((cat) => {
        return { ...cat, totalCount: 0, totalAmount: 0 };
      });
      this.subCategoriesList = this.subCategories?.map((cat) => {
        return { ...cat, totalCount: 0, totalAmount: 0 };
      });
      this.products?.forEach((item) => {
        $this.getChannels.forEach((channel) => {
          $this.itemTotalPrice += Number(item.price) * Number(item[channel]);
        });
      });

      this.products?.forEach((item) => {
        var row = [],
          data = {},
          totalCount = 0,
          totalAmount = 0,
          cIndex = null,
          scIndex = null;

        if (item.category_id) {
          cIndex = $this.mainCategoriesList.findIndex(
            (el) => el.id == item.category_id
          );
          if (!$this.checkShowCategory(item.category_id)) {
            $this.showCategories.push(item.category_id);
          }
        }
        if (item.subcategory_id) {
          scIndex = $this.subCategoriesList.findIndex(
            (el) => el.id == item.subcategory_id
          );
          if (!$this.checkShowSubCategory(item.subcategory_id)) {
            $this.showSubCategories.push(item.subcategory_id);
          }
        }
        data.value = "";
        data.category_id = item.category_id;
        data.subcategory_id = item.subcategory_id;
        data.visible = false;
        row.push({ ...data });
        data = {};
        data.value = "name";
        data.label = item.name;
        data.amount = item.price;
        data.dish_type = item.dish_type ? JSON.parse(item.dish_type)?.[0] : "";
        data.visible = true;
        row.push({ ...data });
        $this.getChannels.forEach((channel) => {
          totalCount += item[channel];
          data.value = channel;
          data.label = item[channel];
          data.amount = item.price * item[channel];
          totalAmount += data.amount;
          data.visible = true;
          row.push({ ...data });
        });
        data.value = "total";
        data.label = totalCount;
        data.amount = totalAmount;
        data.visible = true;
        row.push({ ...data });

        // data.value = "category_id";
        // data.label = item.category_id;
        // data.visible = false;
        // row.push({ ...data });
        // row.category_id = item.category_id;

        data.value = "revenue";
        data.label =
          Math.round(
            ((totalCount * item.price) / $this.itemTotalPrice) * 10000
          ) / 100;
        data.amount = totalCount * item.price;
        data.visible = true;
        row.push({ ...data });
        $this.items.push(row);
        if (cIndex !== null && cIndex >= 0) {
          $this.mainCategoriesList[cIndex].totalCount += totalCount;
          $this.mainCategoriesList[cIndex].totalAmount += totalAmount;
        }
        if (scIndex !== null && scIndex >= 0) {
          $this.subCategoriesList[scIndex].totalCount += totalCount;
          $this.subCategoriesList[scIndex].totalAmount += totalAmount;
        }
      });
      this.titles = JSON.parse(JSON.stringify(this.FIXED_TITLE));
      this.titles.splice(
        1,
        0,
        ...this.getChannels.map((channel) => {
          return { value: channel, text: channel };
        })
      );
    },
    getColor(amount) {
      const limiter = (this.averageRevenueFromItem * 2) / 3;
      if (amount < limiter) {
        return "red darken-1";
      } else if (amount < 2 * limiter) {
        return "yellow darken-1";
      } else {
        return "green accent-4";
      }
    },
    hanldeSort(title) {
      this.page = 1;
      if (title.value !== this.sortBy) {
        this.sortBy = title.value;
        this.sortOrder = "asc";
      } else {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      }
    },
    getItemProperty(ItemArray, value, property) {
      const item = ItemArray.find((item) => item.value === value);
      return item ? item[property] : property === "amount" ? 0 : "";
    },
    handleShowItemWiseSalesDetails(index) {
      this.selectedIndex = index;
      this.showItemWiseSalesDetails = true;
    }
  }
};
